import { render, staticRenderFns } from "./EditWebhook.vue?vue&type=template&id=77a8ec38&scoped=true&"
import script from "./EditWebhook.vue?vue&type=script&lang=ts&"
export * from "./EditWebhook.vue?vue&type=script&lang=ts&"
import style0 from "./EditWebhook.vue?vue&type=style&index=0&id=77a8ec38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8ec38",
  null
  
)

export default component.exports